import { Box } from "@mui/material";
import React from "react";
import { Outlet } from "react-router-dom";
import MainFooter from "../components/mainComponents/mainFooter";
import MainHeader from "../components/mainComponents/mainHeader";
import MobileBottomTab from "../components/tabs/mobileBottomTab";
import { checkLogin } from "../utils/functions";
import { useLocation } from "react-router-dom";
import InstallPrompt from "../components/pwa/InstallPrompt";

export default function MainLayout(){
    const location = useLocation();
    const showBottomTab = checkLogin() && location.pathname !== "/";
    return(
        <Box
        sx={{
            maxWidth:"1920px",
            position:"relative",
            margin:"auto",
            "--mobile-bottom-tab-height": "84px",
            
        }}
        >
            <MainHeader/>
            <Box sx={{ pb: showBottomTab ? { xs: "calc(var(--mobile-bottom-tab-height) + env(safe-area-inset-bottom, 0px))", md: 0 } : 0 }}>
                <Outlet />
            </Box>
            {/* <MainFooter/> */}
            {showBottomTab && <MobileBottomTab />}
            <InstallPrompt />
        </Box>
    )
}